import * as Yup from 'yup';

// W-0626 — RN-01: GE obrigatório; Família opcional (paridade messagedlg('GE inválido!')).
export const filtrosSchema = Yup.object().shape({
  codigoGrupoEmpresa: Yup.number()
    .typeError('Grupo de Empresa deve ser informado.')
    .required('Grupo de Empresa deve ser informado.')
    .positive('Grupo de Empresa deve ser informado.'),
  codigoFamilia: Yup.number().nullable(),
});
